import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/products/categories/${id}`, 'get', {}, {});
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/categories/${id}`, 'put', body, {});
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/categories/`, 'post', body, {});
  },
  delete: async (id) => {
    return request(`${API_URL}/products/categories/${id}`, 'delete', {}, {});
  },

  pullGombaCategories: async () => {
    return request(`${API_URL}/products/categories/pull-gomba-categories`, 'post', {}, {});
  }
};
